module.exports = __webpack_public_path__ + "static/assets/301800953e877d4de5f21695a79b4b30.svg";